import React from "react";
import { Link } from "react-router-dom";
import { IconWithTextCellProps } from "../types";

const iconColorClasses = {
  brand: "bg-brand-50 dark:bg-brand-900/20 text-brand-500 dark:text-brand-400",
  purple:
    "bg-purple-50 dark:bg-purple-900/20 text-purple-500 dark:text-purple-400",
  blue: "bg-blue-50 dark:bg-blue-900/20 text-blue-500 dark:text-blue-400",
  green: "bg-green-50 dark:bg-green-900/20 text-green-500 dark:text-green-400",
  red: "bg-red-50 dark:bg-red-900/20 text-red-500 dark:text-red-400",
};

export const IconWithTextCell: React.FC<IconWithTextCellProps> = ({
  icon: Icon,
  iconColor = "brand",
  primaryText,
  secondaryText,
  primaryLink,
  onPrimaryClick,
  className = "",
}) => {
  const iconClasses = iconColorClasses[iconColor];

  const primaryContent = (
    <p className="font-medium text-sm text-gray-900 dark:text-gray-100">
      {primaryText}
    </p>
  );

  const primaryWithLink = primaryLink ? (
    <Link
      to={primaryLink}
      className="font-medium text-sm text-gray-900 dark:text-gray-100 hover:text-brand-600 dark:hover:text-brand-400 transition-colors break-words"
    >
      {primaryText}
    </Link>
  ) : onPrimaryClick ? (
    <button
      onClick={onPrimaryClick}
      className="font-medium text-gray-900 dark:text-gray-100 hover:text-brand-600 dark:hover:text-brand-400 transition-colors text-left"
    >
      {primaryText}
    </button>
  ) : (
    primaryContent
  );

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div
        className={`flex h-10 w-10 items-center justify-center rounded-lg flex-shrink-0 ${iconClasses
          .split(" ")
          .slice(0, 2)
          .join(" ")}`}
      >
        <Icon
          className={`h-5 w-5 ${iconClasses.split(" ").slice(2).join(" ")}`}
        />
      </div>
      <div className="min-w-0 flex-1">
        {primaryWithLink}
        {secondaryText && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            {secondaryText}
          </p>
        )}
      </div>
    </div>
  );
};
